import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { map, tap } from 'rxjs/operators';
import { enrichParties } from '../../../domain/document.model';
import { Policy } from '../../../domain/policy.model';
import { FileService } from '../service/file.service';
import { PolicyService } from '../service/policy.service';
import { PolicyAction } from './policy.action';

export class PolicyStateModel {
    policies: Policy[];
}

@State<PolicyStateModel>({
    name: 'policy',
    defaults: {
        policies: null,
    }
})
@Injectable()
export class PolicyState {

    constructor(private policyService: PolicyService,
                private fileService: FileService) {
    }

    @Selector()
    static getPolicies(state: PolicyStateModel) {
        return state.policies;
    }

    @Action(PolicyAction.GetListByOfferId)
    getListByOfferId(context: StateContext<PolicyStateModel>, action: PolicyAction.GetListByOfferId) {
        return this.policyService.getListByOfferId(action.id)
            .pipe(map(policies => {
                policies.forEach(p => enrichParties(p));
                context.patchState({policies})
            }));
    }

    @Action(PolicyAction.Printout)
    printout(context: StateContext<PolicyStateModel>, action: PolicyAction.Printout) {
        return this.policyService.print(action.id, action.all)
            .pipe(tap(file => {
                this.fileService.getFileByToken(file.token);
            }));
    }

    @Action(PolicyAction.PrintoutSummary)
    printoutSummary(context: StateContext<PolicyStateModel>, action: PolicyAction.PrintoutSummary) {
        return this.policyService.printSummary(action.id)
            .pipe(tap(file => {
                this.fileService.getFileByToken(file.token);
            }));
    }

    @Action(PolicyAction.PrintoutFrontierCertificate)
    printoutFrontierCertificate(context: StateContext<PolicyStateModel>, action: PolicyAction.PrintoutFrontierCertificate) {
        return this.policyService.printFrontierCertificate(action.id)
            .pipe(tap(file => {
                this.fileService.getFileByToken(file.token);
            }));
    }


}
